import { BehaviorSubject } from 'rxjs';
export enum SeSideComponentType {
    patientHistory = 'patientHistory',
    reportPreview = 'reportPreview', // SOLO TEST
    keyImagesPreview = 'keyImagesPreview',
    reporting = 'reporting',
    details = 'details'
}

export abstract class SeSideComponentBase {
    isLoading = new BehaviorSubject<boolean>(false);
}
